import React, { useEffect, useState } from "react";
import { components } from "react-select";

import Select from "react-select";
import { formatString } from "./CommunicationModal";

const CustomClearText = () => "clear all";
const CustomMultiValue = (props) => {
  const { index, getValue } = props;
  const maxToShow = 1;
  const values = getValue();
  const overflow = values.length - maxToShow;

  if (index < maxToShow) {
    return <components.MultiValue {...props} />;
  }

  if (index === maxToShow) {
    return (
      <div style={{ marginLeft: 6, fontSize: "13px", color: "#555" }}>
        +{overflow} more
      </div>
    );
  }

  return null;
};

const ClearIndicator = (props) => {
  const {
    children = <CustomClearText />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props)}
    >
      <div style={{ padding: "0px 5px" }}>{children}</div>
    </div>
  );
};

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "blue" : "black",
});
const multiValueStyles = {
  multiValue: (base, state) =>
    state.index > 0
      ? { ...base, display: "none" }
      : base,
};

function CommunicateMultiSelect({
  handleSubCategories = () => {},
  subCategoryType = [],
  data,
  requiredValue = formatString(data?.notificationFor?.notification_for_name) !==
  "website"
    ? true
    : false,
   
}) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (subCategoryType?.length === 0) {
      setSelectedOptions([]);
    }
  }, [subCategoryType]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    handleSubCategories(selectedOptions);
  };

  const handleSelectAll = () => {
    const allOptions = subCategoryType?.map((ele) => ({
      label: ele?.sub_category_name,
      value: ele?.sub_category_name.toLowerCase().split(" ").join(""),
    }));
    setSelectedOptions(allOptions);
    handleSubCategories(allOptions);
  };

  const options =
    data?.CategoryType !== ""
      ? subCategoryType?.map((ele) => ({
          label: ele?.sub_category_name,
          value: ele?.sub_category_name.toLowerCase().split(" ").join(""),
        }))
      : [];

  const customOptions = [{ label: "All", value: "all" }, ...options];

  const handleCustomChange = (selected) => {
    if (selected.some((option) => option.value === "all")) {
      handleSelectAll();
    } else {
      handleChange(selected);
    }
  };

  return (
    <Select
      value={selectedOptions}
      onChange={handleCustomChange}
      closeMenuOnSelect={false}
      components={{ ClearIndicator,
        MultiValue: CustomMultiValue,
       }}
      styles={{ clearIndicator: ClearIndicatorStyles,
        ...multiValueStyles,
         control: (provided) => ({
      ...provided,
      minHeight: "50px",   // ⬅️ increase height here
      height: "50px",
    })
       }}
      isMulti
      options={customOptions}
      required={requiredValue}
    />
  );


}

export default React.memo(CommunicateMultiSelect);
